import {
  ParametricAssetId,
  //SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  L: number; // Longueur
  e: number; // Hauteur gauche
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.TUNNEL_HEAD,
  image: "/images/assets/tete-tunnel.png",
  //submittedBy: SubmittingOrganization.ARS,
  inputs: [
    {
      key: "L",
      type: "dimension",
    },
    {
      key: "e",
      type: "dimension",
    },
  ],
  build: (params, offset) => {
    const { L, e } = params;
    const Li = 2 * e + L;
    return [
      {
        type: "circle-arc",
        start: [-L / 2 + offset[0], offset[1], offset[2]],
        middle: [0 + offset[0], L / 2 + offset[1], offset[2]],
        end: [L / 2 + offset[0], offset[1], offset[2]],
      },
      {
        type: "circle-arc",
        start: [-Li / 2 + offset[0], 0 + offset[1], offset[2]],
        middle: [0 + offset[0], Li / 2 + offset[1], offset[2]],
        end: [Li / 2 + offset[0], 0 + offset[1], offset[2]],
      },
      {
        type: "polyline",
        points: [
          [-Li / 2 + offset[0], 0 + offset[1], offset[2]],
          [Li / 2 + offset[0], 0 + offset[1], offset[2]],
        ],
      },
    ];
  },
};

export default asset;
